var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"RequestSearchInput",attrs:{"value":_vm.value,"placeholder":_vm.$tc('orders.orderDetail.listView.search'),"append-icon":"mdi-magnify"},on:{"input":function($event){return _vm.handleInput($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }